import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { DeletedAttachment, FieldSettings, MenuOptions } from "./editor-emitter.dto";
import { Editor } from "@tiptap/core";
import { TemplateType } from "../templates/template.dto";

@Injectable({
    providedIn: 'root'
})

export class EditorEmitterService {

    private editorTrigger = new EventEmitter<FieldSettings>();
    private select_template = new EventEmitter<boolean>();
    private openSideManu = new Subject<MenuOptions>();
    public shouldBackToRecipientView = new Subject<boolean>();
    public deleteAttachment = new Subject<DeletedAttachment>();
    public updateEditor = new Subject<Editor>();
    public currentTemplateType$ = new BehaviorSubject<TemplateType>(TemplateType.REGULAR);
    public documentCurrency$ = new BehaviorSubject<string>('');
    /**
     * Trigger emit
     * @param action 
     * @returns response
     */
    triggerEmitter(action: FieldSettings){
        this.editorTrigger.emit(action)
    }



    /**
     * Get trigger
     * @returns Emitter
     */
    getTriggers(){
        return this.editorTrigger;
    }

    /**
     * trigger unsaved chnages popup trigger
     * @param action 
     */
    setUnsavedChangesFlag(action: boolean){
        this.select_template.emit(action);
    }

    /**
     * get the emit listener
     * @returns 
     */
    getUnSavedChangesFlag(){
        return this.select_template;
    }
    
    /**
     * trigger event when manu is opened
     * @param options 
     */
    triggerOpenMenuAction(options:MenuOptions){
        this.openSideManu.next(options);
    }

    /**
     * get the emit listener
     * @returns 
     */
    getSideMenuOptions(){
        return this.openSideManu.asObservable();
    }

    
    
    /**
     * Updates the current template type by emitting the provided value to the `currentTemplateType$` observable.
     *
     * @param val - The new template type to set as the current value.
     */
    setCurrentTemplateType(val: TemplateType) {
        this.currentTemplateType$.next(val);
    }

    
    /**
     * Returns the current template type for the eForm.
     *
     * @returns {TemplateType} The type of the current eForm template.
     */
    getCurrentTemplateType(): TemplateType {
        return this.currentTemplateType$.getValue();
    }

    setDocumentCurrency(val: string) {
        this.documentCurrency$.next(val);
    }

    getDocumentCurrency(): string {
        return this.documentCurrency$.getValue();
    }
}